import axios from "axios";
import { DbAccess } from "./token";



export function getData(access: DbAccess) {
    const options = {
        params: {offset: '0', limit: '250', where: '', viewId: access.viewId},
        headers: {
            'xc-token': access.token
        }
    };
    return new Promise<BoardApiType>((resolve, reject) => {
        axios.get(import.meta.env.VITE_NOCO_DB_TABLE_URL + access.tableId + '/records', options)
            .then(res => {
                resolve(res.data)
            }).catch((e) => {
            reject(e)
        })
    });
}
